export const ko = {
  recently_used: '최근 사용',
  smileys_emotion: '스마일리',
  people_body: '사람 및 신체',
  animals_nature: '동물 및 자연',
  food_drink: '음식 및 음료',
  travel_places: '여행 및 장소',
  activities: '활동',
  objects: '사물',
  symbols: '기호',
  flags: '깃발',
  search: '검색'
};
export default ko;
//# sourceMappingURL=ko.js.map